import React, { Component } from "react";
import Header from "./layout/Header";
import Footer from "./layout/Footer";
import { Checkbox, Radio, Space, DatePicker } from "antd";
import Bridge from "./utils/Bridge";
import { RESEARCH_TYPE } from "./utils/consts";
import moment from "moment";
import dayjs from "dayjs";

export default class ViewConsentForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      active_step: "0",
      i_accept_checkbox: "",
      permission_to_link_clinical_info: "",
      permission_to_contact_third_parties: "",
      participant_in_familial_als_group_meetings: "",
      electronic_signature_acknowledgment: "",
      consent_form_status: false,
      ecas_user_type: "",
      ecas_is_accepted: false,
      consent_form_date: "",
    };
  }
  componentDidMount() {
    this.get_demographic_details();
  }
  get_demographic_details = () => {
    let params = "?eals_id=" + localStorage.getItem("ap_eals_id");
    if (RESEARCH_TYPE == "Asymptomatic Study") {
      Bridge.demographics
        .get(params)
        .then((response) => {
          this.setState({ loading: false });
          if (response.status == "1") {
            if (response.data.length > 0) {
              for (let item of response.data) {
                if (item.field == "Acknowledgment Signature Full Name") {
                  this.setState({ full_name: item.value });
                }
                if (item.field == "Acknowledgment Signature Date") {
                  this.setState({ signature_date: item.value });
                }
                if (item.field == "Familial ALS Group Meetings") {
                  this.setState({
                    participant_in_familial_als_group_meetings: item.value,
                  });
                }
              }
            }
          }
        })
        .catch((error) => {
          this.setState({ loading: false });
        });
    } else if (RESEARCH_TYPE == "ECAS Study") {
      Bridge.demographics.ecas_study
        .get(params)
        .then((response) => {
          this.setState({ loading: false });
          if (response.status == "1") {
            if (response.data.length > 0) {
              for (let item of response.data) {
                if (item.field == "Consent form signed?") {
                  this.setState({
                    ecas_is_accepted: item.value == "Yes" ? true : false,
                  });
                }
                if (item.field == "User Type") {
                  this.setState({ ecas_user_type: item.value });
                }
              }
            }
          }
        })
        .catch((error) => {
          this.setState({ loading: false });
        });
    } else if (RESEARCH_TYPE == "LE Study") {
      Bridge.demographics.le_study
        .get(params)
        .then((response) => {
          this.setState({ loading: false });
          if (response.status == "1") {
            if (response.data.length > 0) {
              for (let item of response.data) {
                if (item.field == "Consent form signed?") {
                  this.setState({
                    ecas_is_accepted: item.value == "Yes" ? true : false,
                  });
                }
                if (item.field == "Consent form signed Date") {
                  this.setState({
                    consent_form_date: item.value ? dayjs(item.value) : "",
                  });
                }
              }
            }
          }
        })
        .catch((error) => {
          this.setState({ loading: false });
        });
    } else {
      let parameter =
        "?participants_accounts_id=" +
        localStorage.getItem("ap_participants_accounts_id");
      Bridge.consent_form.speech
        .check_consent_form_status(parameter)
        .then((response) => {
          this.setState({ loading: false });
          if (response.status == "1") {
            this.setState({ consent_form_status: response.data });
          }
        })
        .catch((error) => {
          this.setState({ loading: false });
        });
    }
  };

  render() {
    return (
      <div>
        <Header />
        <div className="main-content demographics-section-wrapper">
          <div className="container">
            <div className="row">
              <div className="col-lg-11 m-auto">
                <div className="demographic-single-section">
                  <a href="/dashboard" className="back-arrow">
                    <box-icon
                      name="chevron-left"
                      color="#fff"
                      style={{ position: "relative", top: 1 }}
                    ></box-icon>
                    Dashboard
                  </a>
                  <div>
                    <div className="header">
                      <h3>CONSENT FORM</h3>
                      <div className="white-block"></div>
                    </div>

                    <div className="form-fields">
                      {RESEARCH_TYPE == "modality.ai" && (
                        <div className="form-group pdf-div">
                          <iframe
                            src="./assets/documents/speech-study-consent-form.pdf#toolbar=0"
                            title="Consent Form"
                            width="100%"
                            height="600px"
                          ></iframe>
                        </div>
                      )}
                      {RESEARCH_TYPE == "Asymptomatic Study" && (
                        <div className="form-group pdf-div">
                          <iframe
                            src="./assets/documents/asymptomatic-consent-form.pdf#toolbar=0"
                            title="Consent Form"
                            width="100%"
                            height="600px"
                          ></iframe>
                        </div>
                      )}
                      {RESEARCH_TYPE == "ECAS Study" && (
                        <div className="form-group pdf-div">
                          <iframe
                            src="./assets/documents/ecas-study-consent-form.pdf#toolbar=0"
                            title="Consent Form"
                            width="100%"
                            height="600px"
                          ></iframe>
                        </div>
                      )}
                      {RESEARCH_TYPE == "modality.ai" && (
                        <div className="form-group">
                          <br />
                          <Checkbox
                            value={"Yes"}
                            checked={this.state.consent_form_status}
                            style={{ fontSize: 17 }}
                          >
                            I Accept
                          </Checkbox>
                        </div>
                      )}
                      {RESEARCH_TYPE == "Asymptomatic Study" && (
                        <>
                          <div className="form-group">
                            <br />
                            <Checkbox
                              value={"Yes"}
                              checked={true}
                              style={{ fontSize: 17 }}
                            >
                              I Accept
                            </Checkbox>
                          </div>
                          <div className="form-group">
                            <Checkbox
                              value={"Yes"}
                              checked={true}
                              style={{ fontSize: 17 }}
                            >
                              I give permission to link my clinical information
                              from PREVENT ALS to my digital data. I understand
                              that means select EverythingALS staff will have
                              access to identifiable clinical information.
                            </Checkbox>
                          </div>
                          <div className="form-group">
                            <Checkbox
                              value={"Yes"}
                              checked={true}
                              style={{ fontSize: 17 }}
                            >
                              I give permission for EverythingALS staff to
                              contact third-parties in order to coordinate
                              linking my digital and clinical information to
                              biosamples
                            </Checkbox>
                          </div>
                          <div className="form-group">
                            <label className="input-heading">Check one:</label>
                            <br />
                            <Checkbox
                              value={"Yes"}
                              onChange={(event) =>
                                this.setState({
                                  participant_in_familial_als_group_meetings:
                                    "I would like to participant in Familial ALS group meetings to provide feedback.",
                                })
                              }
                              checked={
                                this.state
                                  .participant_in_familial_als_group_meetings ==
                                "I would like to participant in Familial ALS group meetings to provide feedback."
                                  ? true
                                  : false
                              }
                              style={{ fontSize: 17 }}
                            >
                              I would like to participant in Familial ALS group
                              meetings to provide feedback.
                            </Checkbox>
                            <Checkbox
                              value={"Yes"}
                              onChange={(event) =>
                                this.setState({
                                  participant_in_familial_als_group_meetings:
                                    "I Do not wish to be invited to the Familial ALS group meetings, and prefer to have one on one sessions.",
                                })
                              }
                              checked={
                                this.state
                                  .participant_in_familial_als_group_meetings ==
                                "I Do not wish to be invited to the Familial ALS group meetings, and prefer to have one on one sessions."
                                  ? true
                                  : false
                              }
                              style={{ fontSize: 17 }}
                            >
                              I Do not wish to be invited to the Familial ALS
                              group meetings, and prefer to have one on one
                              sessions.
                            </Checkbox>
                          </div>
                          <div className="form-group">
                            <label className="input-heading">
                              Electronic Signature Acknowledgment{" "}
                              <span className="text-danger">*</span>
                            </label>
                            <Checkbox
                              value={"Yes"}
                              checked={true}
                              style={{ fontSize: 17 }}
                            >
                              I understand what the study is about, and my
                              questions so far have been answered. I agree to
                              take part of this study.
                            </Checkbox>
                          </div>
                          <div className="form-group">
                            <div className="row">
                              <div className="col-lg-6">
                                <label className="input-heading">
                                  Full Name{" "}
                                  <span className="text-danger">*</span>
                                </label>
                                <input
                                  type="text"
                                  name="full_name"
                                  placeholder="Full Name"
                                  value={this.state.full_name}
                                />
                              </div>
                              <div className="col-lg-6">
                                <label className="input-heading">
                                  Date <span className="text-danger">*</span>
                                </label>
                                <input
                                  type="text"
                                  placeholder="Date"
                                  name="signature_date"
                                  value={this.state.signature_date}
                                />
                              </div>
                            </div>
                          </div>
                        </>
                      )}
                      {RESEARCH_TYPE == "ECAS Study" && (
                        <>
                          <div className="form-group">
                            <br />
                            <Checkbox
                              value={"Yes"}
                              checked={this.state.ecas_is_accepted}
                              style={{ fontSize: 17 }}
                            >
                              I Accept
                            </Checkbox>
                          </div>
                        </>
                      )}
                      {RESEARCH_TYPE == "LE Study" && (
                        <>
                          <div className="form-group pdf-div">
                            <iframe
                              src="./assets/documents/ecas-study-consent-form.pdf#toolbar=0"
                              title="Consent Form"
                              width="100%"
                              height="600px"
                            ></iframe>
                          </div>
                          <div className="form-group">
                            <br />
                            <Checkbox
                              value={"Yes"}
                              checked={this.state.ecas_is_accepted}
                              style={{ fontSize: 17 }}
                            >
                              I Accept
                            </Checkbox>
                          </div>
                          <div className="form-group col-lg-5 pl-0">
                            <label
                              htmlFor="consent-form-date mb-2"
                              style={{ fontSize: 17, marginBottom: 10 }}
                            >
                              Consent Form Date{" "}
                              <span className="text-danger">*</span>
                            </label>
                            <DatePicker
                              id="consent-form-date"
                              className="form-control"
                              value={this.state.consent_form_date}
                              format="MM/DD/YYYY"
                              inputReadOnly
                              open={false}
                              allowClear={false}
                            />
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    );
  }
}
